function CategoryBadge({ categoria, className = '', onClick }) {
  if (!categoria) return null;

  const style = {
    backgroundColor: `${categoria.cor}15`,
    color: categoria.cor,
    borderColor: `${categoria.cor}30`,
  };

  const Tag = onClick ? 'button' : 'span';

  return (
    <Tag
      className={`inline-flex items-center px-2.5 py-1 text-xs font-semibold rounded-full border ${onClick ? 'cursor-pointer hover:opacity-80' : ''} ${className}`}
      style={style}
      onClick={onClick}
    >
      {categoria.nome}
    </Tag>
  );
}

export default CategoryBadge;
